import React from 'react';
// styles
import useStyles from '../../../assets/styles/jss/pages/exploreHome/bannerTestingStyle'
import clsx from 'clsx';
//material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useMediaQuery, useTheme } from '@material-ui/core';

//assets/images
import ResponsiveContainer from '../../../shared/components/ResponsiveContainer/ResponsiveContainer';

import { eventData, eventTracker } from '../../../shared/components/EventTracker/EventTracker';
import Banner from './Banner';
import { bannersPromotion } from '../../../shared/constants/bannersPromotion';

const BannerTesting = ({ onClickLogin, type }) => {
    const classes = useStyles(bannersPromotion[type]);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // md y superiores (laptop/desktop)

    const handleToEvent = () => {

        eventData['source'] = 'ExploreHome';
        eventData['NameBanner'] = bannersPromotion[type].btn1.title;
        eventData['LinkBanner'] = bannersPromotion[type].btn1.link;
        eventTracker('Banner', eventData, ['mixpanel']);
    };

    if (type === 2) {
        return <Banner onClickLogin={onClickLogin} />
    }

    // if (
    //     !(banners[type]?.startDate && banners[type]?.endDate &&
    //         moment().startOf('day').isSameOrAfter(moment(banners[type]?.startDate, 'YYYY-MM-DD').startOf('day')) &&
    //         moment().startOf('day').isSameOrBefore(moment(banners[type]?.endDate, 'YYYY-MM-DD').startOf('day')))
    // ) return <Banner onClickLogin={onClickLogin}/>

    return (
        <Box className={clsx(classes.root, (bannersPromotion[type]?.rootBgLarge && classes.rootBgLarge))}>
            <div className={classes.bgResponsive}></div>
            <Box className={clsx(classes.bgImage)} />
            <ResponsiveContainer className={classes.responsiveContainer}>
                <Box width={600} display='flex' gridGap={24} flexDirection='column' className={clsx(classes.container, (bannersPromotion[type]?.downTitleImg && classes.downTitleImg))}>
                    {bannersPromotion[type]?.blockImgSecondary && (
                        (!bannersPromotion[type]?.blockImgSecondaryMobile && !bannersPromotion[type]?.blockImgSecondaryDesktop) ||
                        (bannersPromotion[type]?.blockImgSecondaryMobile && !isDesktop) ||
                        (bannersPromotion[type]?.blockImgSecondaryDesktop && isDesktop)
                    ) && <Box className={classes.blockImgSecondary} />}
                    {bannersPromotion[type]?.imgSecondary1 && (
                        <Box>
                            <img src={bannersPromotion[type]?.imgSecondary1} className={classes.imgPrimary} style={bannersPromotion[type]?.imgPrimaryStyle || {}} />
                        </Box>
                    )}
                    {bannersPromotion[type]?.imgSecondary2 && (
                        <img src={bannersPromotion[type]?.imgSecondary2} className={classes.imgSecondary} />)}

                    <Box width={'100%'} display='flex' gridGap={24} flexDirection='column'>
                        {bannersPromotion[type]?.desc?.texts.map((desc, index) => {
                            if (desc?.parts) {
                                // Renderizar texto con partes de diferentes colores
                                const hasLineBreak = desc.parts.some(part => part.text.includes('\n'));
                                const typographyStyle = { ...(desc?.style?.css || {}) };
                                // Solo aplicar fontSize en desktop/laptop, no en mobile
                                if (!isDesktop && typographyStyle.fontSize) {
                                    delete typographyStyle.fontSize;
                                }
                                if (hasLineBreak) {
                                    typographyStyle.whiteSpace = 'pre-line';
                                }
                                return (
                                    <Typography key={index} variant={desc?.style?.variant}
                                        style={typographyStyle}
                                        align='left'>
                                        {desc.parts.map((part, partIndex) => {
                                            const partStyle = { ...(part.css || {}) };
                                            // Solo aplicar fontSize, fontWeight y bold en desktop/laptop, no en mobile
                                            if (isDesktop) {
                                                if (part.fontSize) partStyle.fontSize = part.fontSize;
                                                if (part.fontWeight) partStyle.fontWeight = part.fontWeight;
                                                if (part.bold) partStyle.fontWeight = partStyle.fontWeight || 'bold';
                                            }
                                            // Siempre mantener otros estilos como color, lineHeight, etc.
                                            // (estos se aplican en el objeto css original)
                                            
                                            return (
                                                <span 
                                                    key={partIndex} 
                                                    className={`text-${part.color || desc?.style?.color}`}
                                                    style={partStyle}
                                                >
                                                    {part.text}
                                                </span>
                                            );
                                        })}
                                    </Typography>
                                );
                            }
                            // Comportamiento original
                            const textStyle = { ...(desc?.style?.css || {}) };
                            // Solo aplicar fontSize en desktop/laptop, no en mobile
                            if (!isDesktop && textStyle.fontSize) {
                                delete textStyle.fontSize;
                            }
                            
                            return (
                                <Typography key={index} variant={desc?.style?.variant}
                                    className={`text-${desc?.style?.color}`} style={textStyle}
                                    align='left'>{desc?.text}</Typography>
                            );
                        })}
                    </Box>
                    {(bannersPromotion[type]?.btn1 || bannersPromotion[type]?.btn2) && (
                        <Box className={classes.actions}>
                            {bannersPromotion[type]?.btn1 && (
                                bannersPromotion[type].btn1.img ?
                                    <Box style={{cursor: 'pointer'}} onClick={()=> window.location.href = bannersPromotion[type].btn1.link}>
                                        <img src={bannersPromotion[type].btn1.img} />
                                    </Box>
                                    : bannersPromotion[type].btn1.link
                                        ? <Button variant="contained" className={clsx(bannersPromotion[type].btn1.color && `bg-${bannersPromotion[type].btn1.color}`)} color="primary" href={bannersPromotion[type].btn1.link}
                                            onClick={handleToEvent} target="_blank">{bannersPromotion[type].btn1.title}</Button>

                                        : bannersPromotion[type].btn1.title && <Button variant="contained" color="primary"
                                            onClick={onClickLogin}>{bannersPromotion[type].btn1.title}</Button>
                            )}
                            {bannersPromotion[type]?.btn2 && (
                                <Link href={bannersPromotion[type].btn2.link} target="_blank" underline="hover" color="secondary"
                                    variant="body2" className="semi-bold">{bannersPromotion[type].btn2.title}</Link>)}
                        </Box>
                    )}
                    {bannersPromotion[type]?.blockImgSecondaryBottom && (
                        (!bannersPromotion[type]?.blockImgSecondaryBottomMobile && !bannersPromotion[type]?.blockImgSecondaryBottomDesktop) ||
                        (bannersPromotion[type]?.blockImgSecondaryBottomMobile && !isDesktop) ||
                        (bannersPromotion[type]?.blockImgSecondaryBottomDesktop && isDesktop)
                    ) && <Box className={classes.blockImgSecondaryBottom} />}
                </Box>
            </ResponsiveContainer>
        </Box>
    )
        ;
};

export default BannerTesting;
